import { BROADCAST_SET_STREAM_STATUS } from 'actions/Types';

const initialState = {};

/**
 * @param {Object} state
 * @param {Object} action
 */
function streamStatus(state = initialState, action) {
  const { type, payload } = action;

  if (type === BROADCAST_SET_STREAM_STATUS) {
    return {
      ...state,
      ...payload
    };
  }

  return state;
}

export default streamStatus;
